import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

// Components
import { IsExportType, StyledWhiteBox } from 'src/features/PortDetail/config';
import ContainerTradeChart from 'src/features/PortDetail/Overview/ContainerTradeChart';
import { get } from 'lodash';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';

// Utilities
import { ITradePortDetailInfo } from 'src/utils/typings/response';
import LoadDischargeChart from 'src/features/PortDetail/Overview/LoadDischargeChart';
import TradeByPartnerChart from 'src/features/PortDetail/Overview/TradeByPartnerChart';
interface IProps {
  portDetail: ITradePortDetailInfo | null;
}

const OverViewTab = ({ portDetail }: IProps) => {
  const youtubeLink = get(getArrayDefault(portDetail?.youtube), '[0]', '');
  const idEmbedYoutube = youtubeLink ? new URL(youtubeLink)?.searchParams.get('v') : '';

  return (
    <React.Fragment>
      <Stack direction="column" spacing={3}>
        <Stack direction="row" spacing={1.5}>
          <ContainerTradeChart locode={portDetail?.meta?.locode || ''} />
          <TradeByPartnerChart locode={portDetail?.meta?.locode || ''} isExport={IsExportType.Import} />
        </Stack>
        <Stack direction="row" spacing={1.5}>
          <LoadDischargeChart locode={portDetail?.meta?.locode || ''} />
          <TradeByPartnerChart locode={portDetail?.meta?.locode || ''} isExport={IsExportType.Export} />
        </Stack>
        {idEmbedYoutube && (
          <Stack>
            <StyledWhiteBox flex={1}>
              <Typography variant="h5" align="left">
                Video
              </Typography>
              <Box mt={2} />
              <iframe width="100%" height="345" src={`https://www.youtube.com/embed/${idEmbedYoutube}`}></iframe>
            </StyledWhiteBox>
          </Stack>
        )}
      </Stack>
    </React.Fragment>
  );
};

export default OverViewTab;
